module.exports = __webpack_public_path__ + "static/media/check-correct-blue.8f93682e.svg";